import React, { Component } from "react";
import Headers from "../Layouts/HeaderReceptionist";
import axios from "axios";
import $ from "jquery";
import Paper from "@mui/material/Paper";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";
import Loader from "../Layouts/Loader";
import { ReceptionSidebar } from "../Layouts/ReceptionSidebar";

export class SearchPatient extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    const TableData = {};
    this.state = { name: "", response: "", DataLoaded: false };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
    this.handleStartVisit = this.handleStartVisit.bind(this);
  }

  handleStartVisit() {}

  handleRowClick(patient) {
    console.log(patient);
    $(".cardClass").hide();
    $(".searchingText").hide();
    $(".card-header").text(patient.Name);
    // $('.card-body').text('Age: '+verified[i]['Age'])
    $(".card-text").text("Age: " + patient.Age);
    $(".MaritalStatus").text("Marital Status: " + patient.MaritalStatus);
    $(".Profession").text("Profession: " + patient.Profession);
    $(".Tel").text("Mobile Number: " + patient.Tel);
    $(".Nationality").text("Nationality: " + patient.Nationality);
    $(".cardClass").show();
    // console.log(patient.patientid)
    $(".cardClick").attr("id", patient.patientid);
    $(".start_visit").attr("id", patient.patientid);
    $(".start_visit").show();
  }
  componentDidMount() {
    const apiurl = this.api_url+"";
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
    };

    //get patients
    axios
      .post(
        this.api_url+"reception/getpatients",
        this.state,
        {
          headers: headers,
        }
      )
      .then((res) => {
        if (res.data) {
          
         
          let tableinit = new Array();
          for (var i = 0; i < res.data.length; i++) {
            console.log(res.data[i]);
            if(res.data[i]["status"] !== ""){
            // console.log(res.data[i]);
        
        
              // if (res.data[i]["module"] == "delivery") {
                var number = i + 1;
                // console.log()
   
  
                tableinit.push(res.data[i]);
  
                console.log((tableinit))
                let object = {};
                for (let i = 0; i < tableinit.length; i++) {
                  delete tableinit[i]._id;
                  delete tableinit[i].timeOfRegistration;
                  tableinit[i].clickEvent = () =>
                    this.handleRowClick(tableinit[i]);
                }
                // table = JSON.stringify(table);
                // var visitId = res.data[i]["visitid"].split("_");
                // var visitNumber = { visitNumber: visitId[2] };
                // var serialNumber = { serialNumber: visitId[1] };
  
                var table = Object.assign(tableinit);
  
                // alert(table)
                this.TableData = table;
                console.log(this.TableData);
                this.setState({
                  DataLoaded: true,
                });
  
                // var searchRow = '<tr><td>'+number+'</td> <td>'+res.data[i]['Name']+'</td><td>'+res.data[i]['Age']+'</td><td>'+res.data[i]['Profession']+'</td><td>'+res.data[i]['MaritalStatus']+'</td><td>'+res.data[i]['Address']+'</td><td>'+res.data[i]['Tel ']+'</td><td>'+res.data[i]['Nationality']+'</td><td>'+date+'</td><td>'+time+'</td><td>'+visitNumber+'</td><td>'+serialNumber+'</td><td></td><td></td><td><a className="btn btn-primary startTreatment" id="'+res.data[i]['visitid']+'">Start Treatment</a></td></tr>'
                // $('.searchClass').append(searchRow)
              }
          
          }


      }
      })
      .catch((error) => {
        console.log("error");
        console.log(error);
      });

    $(".searchPatient").on("keyup", function () {});
    $(".start_visit").on("click", function () {
      if (
        window.confirm(
          "Are you sure you want to start visit for this patient?"
        ) == true
      ) {
        var patientid = $(this).attr("id");

        const headers = {
          "Content-Type": "application/json",
          token: localStorage.getItem("accessToken"),
          patientid: patientid,
          "Access-Control-Allow-Origin": "*",
        };

        axios
          .post(apiurl + "reception/newvisits", this.state, {
            headers: headers,
          })
          .then((res) => {
            localStorage.setItem("visitId", res.data["visitid"]);
            console.log("visitid:::" + res.data["visitid"]);
            const headersonepatient = {
              "Content-Type": "application/json",
              token: localStorage.getItem("accessToken"),
              visitid: res.data["visitid"],
              "Access-Control-Allow-Origin": "*",
            };
            axios
              .get(apiurl + "reception/onepatient", {
                headers: headersonepatient,
              })
              .then((res) => {
                //   const verified = res.data;
                // console.log(res.data[0]['Name'])

                localStorage.removeItem("onepatientName");
                localStorage.removeItem("onepatientNationality");
                localStorage.removeItem("onepatientProfession");
                localStorage.removeItem("onepatientAge");
                // alert(res.data[0]['Name'])
                localStorage.setItem("onepatientName", res.data[0]["Name"]);
                localStorage.setItem(
                  "onepatientNationality",
                  res.data[0]["Nationality"]
                );
                localStorage.setItem(
                  "onepatientProfession",
                  res.data[0]["Profession"]
                );
                localStorage.setItem("onepatientAge", res.data[0]["Age"]);

                $(".onepatientName").text(res.data[0]["Name"]);
                $(".onepatientNationality").text(res.data[0]["Nationality"]);
                $(".onepatientProfession").text(res.data[0]["Profession"]);
                $(".onepatientAge").text(res.data[0]["Age"]);

                $(".module_list").show();
              })
              .catch((error) => {
                console.log(error);
              });

            const headers2 = {
              "Content-Type": "application/json",
              token: localStorage.getItem("accessToken"),
              visitid: res.data["visitid"],
            };
            console.log(headers2);

            var dict = {
              procedurename: "admission",
            };
            console.log();
            axios
              .post(apiurl + "billing/triage/create", dict, {
                headers: headers2,
              })
              .then((res) => {
                console.log(res.data);
              })
              .catch((error) => {
                console.log(error);
              });
            //   this.setState({ verified });
            // console.log(res);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });

    
    $(".close").on("click", function () {
      $(".modal").hide();
    });

    $(".moduleSelect").click(function () {
      $(thisId).toggle(
        function () {
          $(this).css("background-color", "black");
        },
        function () {
          $(this).css("background-color", "grey");
        }
      );
      console.log(localStorage.getItem("visitId"));

      var thisId = $(this).attr("id");
      // console.log(thisId)
      const headers = {
        "Content-Type": "application/json",
        token: localStorage.getItem("accessToken"),
        visitid: localStorage.getItem("visitId"),
        "Access-Control-Allow-Origin": "*",
      };
      // console.log(this.state)
      axios
        .post(apiurl + "billing/status/triage/open", this.state, {
          headers: headers,
        })
        .then((res) => {
          //   const verified = res.data;
          console.log(res.data);
          if (res.data["status"]) {
            $(".sendModuleSuccess").show();
            setTimeout(function (props) {
              $(".sendModuleSuccess").hide();
              $(".modal").hide();
            }, 3000);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  handleSubmit = (event) => {
    // resultDisplay
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      "Access-Control-Allow-Origin": "*",
    };
    event.preventDefault();
    $(".searchingDisplay").html(
      '<div className="alert alert-primary searchingText" role="alert">Searching...</div>'
    );
    $(".cardClass").hide();
    $(".NoResults").hide();
    console.log(this.state);
  
  };

  render() {
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const height395 = {
      height: "125px",
      lineHeight: "395px",
      textAlign: "center",
    };
    const height222 = {
      height: "222px",
      lineHeight: "220px",
      textAlign: "center",
    };
    const displayHidden = { display: "none", color: "red" };

    // console.log(this.TableData);
    const { name } = this.state;
    let { DataLoaded } = this.state;
    const data = {
      columns: [
        {
          label: "Patient ID",
          field: "patientid",
          sort: "asc",
          width: 50,
        },
        {
          label: "Name",
          field: "Name",
          sort: "asc",
          width: 270,
        },
        {
          label: "Date Of Birth",
          field: "Dateofbirth",
          sort: "asc",
          width: 100,
        },
        {
          label: "Age",
          field: "Age",
          sort: "asc",
          width: 100,
        },
        {
          label: "Profession",
          field: "Profession",
          sort: "asc",
          width: 150,
        },
        {
          label: "Marital Status",
          field: "MaritalStatus",
          sort: "asc",
          width: 100,
        },
        {
          label: "Tel",
          field: "Tel",
          sort: "asc",
          width: 100,
        },
        {
          label: "Address",
          field: "Address",
          sort: "asc",
          width: 100,
        },
        {
          label: "Education",
          field: "Education",
          sort: "asc",
          width: 100,
        },
        {
          label: "Nationality",
          field: "Nationality",
          sort: "asc",
          width: 100,
        },
      ],
      rows: this.TableData,
    };

    const onepatientName = localStorage.getItem("onepatientName");
    const onepatientNationality = localStorage.getItem("onepatientNationality");
    const onepatientProfession = localStorage.getItem("onepatientProfession");
    const onepatientAge = localStorage.getItem("onepatientAge");
    return (
      <div>
        <Headers />
        <ReceptionSidebar></ReceptionSidebar>
        <main className="content-container">
          <div className="container">
            <div className="row pl-2">
              {DataLoaded ? (
                <MDBDataTable striped bordered data={data} />
              ) : (
                <Loader></Loader>
              )}
              <div className="col-md-6 py-3">
                <div>
                  {/* <h4 style={fontFamilyNunito}>Search for a patient</h4>
                                    <h6 className="text-muted" style={fontFamilyNunito}>Select Patient</h6> */}
                  <form onSubmit={this.handleSubmit}>
                    {/* <div className="py-3 my-2">
                                            <div className="input-group">
                                                <div className="input-group-prepend"></div><input className="form-control searchPatient" type="text" onChange={this.handleChange} value={name} name="name" placeholder="Search..." style={fontFamilyNunito} required />
                                                <div className="input-group-append"><button className="btn btn-primary btn-secondary" type="submit"><i className="fa fa-search"></i></button></div>
                                            </div>
                                        </div> */}
                    <div className="resultDisplay">
                      <div className="searchingDisplay"></div>
                      <div className="cardClick" id="">
                        <div className="card cardClass" style={displayHidden}>
                          {" "}
                          <div className="card-header"></div>{" "}
                          <div className="card-body">
                            <h5 className="card-title"> </h5>
                            <p className="MaritalStatus"></p>
                            <br />
                            <p className="Profession"></p>
                            <br />
                            <p className="Tel"></p>
                            <br />
                            <p className="Nationality"></p>
                            <br />
                            <button
                              onClick={this.handleStartVisit}
                              className="btn btn-primary start_visit"
                              id=""
                            >
                              Start Client Visit
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        id="NoResults"
                        className="alert alert-danger"
                        style={displayHidden}
                        role="alert"
                      >
                        <strong>Sorry, </strong> No Results Found
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="col-md-6">
                {/* <div className="border border-dark rounded text-center align-items-center" style={height395}>
                        <p style={ fontFamilyNunito }>Search results will appear here</p>
                    </div> */}
              </div>
            </div>
          </div>
          <div className="modal resultModal" tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title PatientName"></h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <p className="age"></p>
                  <span className="mobile_number"></span>
                  <br />
                  <span className="Profession"></span>
                  <br />
                  <span className="MaritalStatus"></span>
                  <br />
                  <span className="Address"></span>
                  <br />
                  <span className="Education"></span>
                  <br />
                  <span className="Nationality"></span>
                  <br />
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary start_visit"
                    id=""
                  >
                    Start Visit
                  </button>
                  {/* <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button> */}
                </div>
              </div>
            </div>
          </div>
          <div className="modal module_list" tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title PatientName"></h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="full-width">
                    <div className="">
                      <a className="navbar-brand" id="triage">
                        Name: <span class="onepatientName"></span>
                        <br />
                        Nationality: <span class="onepatientNationality"></span>{" "}
                        <br />
                        Age: <span class="onepatientAge"></span>
                        <br />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <a className="btn btn-primary moduleSelect">Send to Triage</a>
                  <br />
                  <p
                    className="alert alert-success sendModuleSuccess"
                    style={displayHidden}
                  >
                    Patient Sent Successfully
                  </p>
                  {/* <button type="button" className="btn btn-primary sendToModule" id="">Send To Module</button> */}
                  {/* <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button> */}
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

export default SearchPatient;
